import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ReqResService } from '../../service/req-res.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

declare var toastr: any;

@Component({
  selector: 'app-reportorder',
  templateUrl: './reportorder.component.html',
  styleUrls: ['./reportorder.component.css']
})
export class ReportorderComponent implements OnInit {

  reportData: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];

  isLoading = false;
  begDate: string = '';
  endDate: string = '';
  searchText: string = '';
  statusId: number = 0;

  currentPage = 1;
  pageSize = 25;

  statusObj: any[] = [];

  constructor(
    private reqRes: ReqResService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Order Report');
  }

  ngOnInit(): void {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    this.begDate = this.formatDate(firstDay);
    this.endDate = this.formatDate(today);
    this.loadStatus();
  }

  loadStatus(): void {
    this.reqRes.getData(`/Report/GetSpecode/ORDER_STATUS`).subscribe(
      (res: any) => {
        this.statusObj = Array.isArray(res) ? res : [];
        this.loadReport();
      },
      error => {
        console.log(error);
        this.isLoading = false;
        toastr.error('Report yüklənmədi');
      }
    );
  }

  loadReport(): void {
    if (!this.begDate || !this.endDate) {
      toastr.warning('Begin date və end date seçilməlidir');
      return;
    }

    this.isLoading = true;

    this.reqRes.getData(`/Report/GetOrderReport?beg=${this.begDate}&end=${this.endDate}&status=${this.statusId}`).subscribe(
      (res: any) => {

        let result: any[] = [];

        if (Array.isArray(res)) result = res;
        else if (typeof res === 'string') result = JSON.parse(res);
        else if (res?.arry) result = typeof res.arry === 'string' ? JSON.parse(res.arry) : res.arry;

        this.reportData = (result || []).map((x: any) => {
          return {
            orderId: x.OrderId,
            orderNo: x.OrderNo,
            userName: x.UserName,
            segment1: x.Segment1,
            segment2: x.Segment2,
            segment3: x.Segment3,
            date: x.Date,
            status: x.Status,
            statusCss: x.StatusCSS, // 🔥 əsas hissə
            totalQty: Number(x.TotalQty || 0),
            totalPrice: Number(x.TotalPrice || 0),
            orderNote: x.OrderNote,

          };
        });

        this.currentPage = 1;
        this.applyFilter();
        this.isLoading = false;
      },
      error => {
        console.log(error);
        this.isLoading = false;
        this.reportData = [];
        this.filteredData = [];
        this.pagedData = [];
        toastr.error('Report yüklənmədi');
      }
    );
  }

  applyFilter(): void {
    const txt = (this.searchText || '').toLowerCase().trim();

    this.filteredData = this.reportData.filter(x =>
      !txt ||
      (x.orderNo || '').toLowerCase().includes(txt) ||
      (x.userName || '').toLowerCase().includes(txt) ||
      (x.segment1 || '').toLowerCase().includes(txt) ||
      (x.segment2 || '').toLowerCase().includes(txt) ||
      (x.segment3 || '').toLowerCase().includes(txt) ||
      (x.date || '').toLowerCase().includes(txt) ||
      (x.status || '').toLowerCase().includes(txt) // 🔥 status search də əlavə etdim
    );

    this.setPagedData();
  }

  setPagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedData = this.filteredData.slice(start, end);
  }

  onSearchChange(): void {
    this.currentPage = 1;
    this.applyFilter();
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.setPagedData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize) || 1;
  }

  get pages(): number[] {
    return Array(this.totalPages).fill(0).map((_, i) => i + 1);
  }

  get totalQty(): number {
    return this.filteredData.reduce((sum, x) => sum + Number(x.totalQty || 0), 0);
  }

  get totalPrice(): number {
    return this.filteredData.reduce((sum, x) => sum + Number(x.totalPrice || 0), 0);
  }

  // 🔥 EXCEL EXPORT (status ilə)
  exportToExcel(): void {
    if (!this.filteredData.length) {
      toastr.warning('Export üçün data yoxdur');
      return;
    }

    const excelData = this.filteredData.map((item, index) => ({
      '#': index + 1,
      'Order ID': item.orderId,
      'Order No': item.orderNo,
      'User': item.userName,
      'Segment Level 1': item.segment1,
      'Segment Level 2': item.segment2,
      'Segment Level 3': item.segment3,
      'Date': item.date,
      'Status': item.status, // ✅ əlavə olundu
      'Total Qty': item.totalQty,
      'Total Price': item.totalPrice,
      'Order Note': item.orderNote
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = { Sheets: { 'Orders': worksheet }, SheetNames: ['Orders'] };

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    FileSaver.saveAs(blob, `Order_Report_${this.begDate}_${this.endDate}.xlsx`);
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const d = ('0' + date.getDate()).slice(-2);
    return `${y}-${m}-${d}`;
  }
}
